import { useSelector } from "react-redux";
import AnalysisPage from "../analysis/AnalysisPage";
import ComprehensivePage from "../comprehensive/ComprehensivePage";
import ParagraphPage from "../paragraph/ParagraphPage";
import VocabularyPage from "../vocabulary/VocabularyPage";

const SectionPage = ({
  setCurrentStep,
  isPreview = false,
  isReview = false,
}) => {
  const { assignment } = useSelector((state) => state.assignment);

  if (assignment.type === "analysis") {
    return (
      <AnalysisPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (assignment.type === "comprehensive") {
    return (
      <ComprehensivePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (assignment.type === "paragraph") {
    return (
      <ParagraphPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (assignment.type === "vocabulary") {
    return (
      <VocabularyPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  return (
    <div>
      <h1>Section Page</h1>
    </div>
  );
};

export default SectionPage;
